import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "nes-container with-title mb-10",
  style: {"display":"none"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Connect to a Farm", -1)
const _hoisted_5 = { class: "nes-field mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "farm" }, "Farm address:", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-full text-center mb-5",
  style: {"display":"none"}
}, " Farmer account not found :( Create a new one? ", -1)
const _hoisted_10 = {
  class: "w-full text-center",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigPane),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Pls connect (burner) wallet"))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                id: "farm",
                class: "nes-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.farm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.farm]
              ])
            ])
          ]),
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(), _createBlock(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"])),
                (_openBlock(), _createBlock(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nes-btn is-primary mr-5",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                        }, " Add Gems (resets staking) "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'unstaked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "nes-btn is-success mr-5",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Begin staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "nes-btn is-error mr-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "nes-btn is-error mr-5",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End cooldown "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "nes-btn is-warning",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                    }, " Claim " + _toDisplayString(_ctx.availableA) + " A / " + _toDisplayString(_ctx.availableB) + " B ", 1)
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft"]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "nes-btn is-primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " New Farmer ")
                ])
              ]))
        ]))
  ], 64))
}